import React, { Component } from 'react';
import { Link } from 'react-router-dom';

//import cookie from 'react-cookie';
import './user.css';

export default class User extends Component {
	constructor(props) {
		super(props);
		this.state = {
			authorized: false,
			id: false,
			name: false,
			hash: false,
		}
	}

	render() {
		console.log('User:', this.props.data);
		const authorized = this.props.data.authorized;

		if(authorized === true) {

			var username = this.props.data.name;

			if(!username)  username = 'No Namer';

			return (
				<ul id="user">
						<li><Link to="/dashboard" className="dashboard">{ username }</Link></li>
							<li><Link to="/settings" className="settings">Settings</Link></li>
						<li><Link to="/logout" className="logout">Log out</Link></li>
				</ul>
			)
		}
		return (
			<ul id="user">
					<li><Link to="/login" className="login">Log in</Link></li>
					<li><Link to="/register" className="register">Register</Link></li>
			</ul>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/user.jsx